import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Don't scroll to top for Western Christian Academy page
    if (pathname === '/western-christian-academy') {
      return;
    }
    
    // Don't scroll to top for Pride Staff Presentation page
    if (pathname === '/pride-staff-presentation') {
      return;
    }
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);
}